import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.object.assign.js";
import _isPlainObject from "lodash/isPlainObject";
var _excluded = ["children"],
    _excluded2 = ["children"];
import "core-js/modules/es.object.define-property.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* eslint-disable react/prop-types */
import React, { forwardRef, useImperativeHandle } from 'react';
import PropTypes from 'prop-types';
import { Button } from '../Button';
import { useForm } from './useForm';
import { formContainer } from './styles';
import { jsx as ___EmotionJSX } from "@emotion/react";
var Form = /*#__PURE__*/forwardRef(function (props, ref) {
  var className = props.className,
      submitButton = props.submitButton,
      cancelButton = props.cancelButton;

  var _useForm = useForm(props),
      loading = _useForm.loading,
      handleSubmit = _useForm.handleSubmit,
      newChildren = _useForm.newChildren,
      formOptions = _useForm.formOptions,
      reset = _useForm.reset;

  useImperativeHandle(ref, function () {
    return _objectSpread(_objectSpread({}, formOptions), {}, {
      reset: reset,
      submit: handleSubmit
    });
  });

  var SubmitButton = function SubmitButton(_ref) {
    var children = _ref.children,
        rest = _objectWithoutProperties(_ref, _excluded);

    return ___EmotionJSX(Button, _extends({
      onClick: handleSubmit,
      disabled: loading
    }, rest), children);
  };

  var CancelButton = function CancelButton(_ref2) {
    var children = _ref2.children,
        rest = _objectWithoutProperties(_ref2, _excluded2);

    return ___EmotionJSX(Button, _extends({
      onClick: reset,
      disabled: loading
    }, rest), children || 'Cancel');
  };

  var onKey = function onKey(el) {
    el.keyCode === 13 && handleSubmit();
  };

  return ___EmotionJSX("div", _extends({
    css: formContainer(props)
  }, className && {
    className: className
  }), ___EmotionJSX("div", {
    onKeyDown: onKey,
    role: "presentation"
  }, newChildren), _isPlainObject(cancelButton) && ___EmotionJSX(CancelButton, cancelButton, cancelButton.children || 'Cancel'), submitButton && ___EmotionJSX(SubmitButton, submitButton, (submitButton === null || submitButton === void 0 ? void 0 : submitButton.children) || 'Submit'));
});
Form.propTypes = {
  className: PropTypes.string,
  loaderClassName: PropTypes.string,
  submitButton: PropTypes.object,
  renderSubmit: PropTypes.func
};
export default Form;